import update from "immutability-helper";
import { FETCH_ASSET, FETCH_ASSET_FAILURE, FETCH_ASSET_SUCCESS, CREATE_CSS_ASSET, IStaticAssets, staticAssetActionTypes, CREATE_IMAGE_ASSET, DELETE_IMAGE_ASSET, CREATE_FONT_ASSET, UPDATE_CSS_ASSET_URL, DELETE_CSS_ASSET_URL, DELETE_FONT_ASSET, CREATE_JSON_ASSET, DELETE_JSON_ASSET } from "./types";

const initialState: IStaticAssets = {
    css: {},
    fonts: {},
    images: {},
    json: {},
    status: ""
}

export const staticAssetReducer = (state = initialState, action: staticAssetActionTypes) => {
    switch (action.type) {
        case FETCH_ASSET:
            return update(state, {
                status: { $set: "Loading" },
            });
        case FETCH_ASSET_SUCCESS:
            return update(state, {
                status: { $set: "Success" },
                css: { $set: action.data.css },
                images: { $set: action.data.images },
                fonts: { $set: action.data.fonts },
                json: { $set: action.data.json },
            });
        case FETCH_ASSET_FAILURE:
            return update(state, {
                status: { $set: "Failure" },
                css: { $set: {} },
                images: { $set: {} },
                fonts: { $set: {
                    googleFontsList: []
                } },
                json: { $set: {} },
            });
        case CREATE_CSS_ASSET:
            return update(state, {
                css: {
                    [action.data.id]: { $set: action.data }
                }
            });
        case CREATE_IMAGE_ASSET:
            return update(state, {
                images: {
                    [action.data.asset.id]: { $set: action.data.asset }
                }
            })
        case DELETE_IMAGE_ASSET:
            const imageIdToRemove = action.data.id;
            return update(state, {
                images: {
                    $unset: [imageIdToRemove],
                }
            });
        case CREATE_FONT_ASSET:
            return update(state, {
                fonts: {
                    [action.data.asset.id]: { $set: action.data.asset }
                }
            });
        case DELETE_FONT_ASSET:
            const fontIdToRemove = action.data.id;
            return update(state, {
                fonts: {
                    $unset: [fontIdToRemove],
                }
            });
        case UPDATE_CSS_ASSET_URL:
            return update(state, {
                css: {
                    [action.data.id]: {
                        url: { $set: action.data.url }
                    }
                }
            })
        case DELETE_CSS_ASSET_URL:
            // ID of the css file you want to remove
            const itemIdToRemove = action.data.id;

            const updatedState = update(state, {
                css: {
                    $unset: [itemIdToRemove],
                }
            });
            return updatedState;
        case CREATE_JSON_ASSET:
            return update(state, {
                json: {
                    [action.data.asset.id]: { $set: action.data.asset }
                }
            })
        case DELETE_JSON_ASSET:
            const jsonIdToRemove = action.data.id;
            return update(state, {
                json: {
                    $unset: [jsonIdToRemove],
                }
            });
        default:
            return state;
    }
}